import { graphql } from "react-relay"

import { TeamCreateMutation } from "./__generated__/TeamCreateMutation.graphql"
import { TeamDeleteMutation } from "./__generated__/TeamDeleteMutation.graphql"
import { TeamUpdateMutation } from "./__generated__/TeamUpdateMutation.graphql"

import { environment } from "~/store/hasura"

import { commitMutationPromise } from "./helpers"
import { viewTeamUrl } from "~/helpers/routes"

import { showToast } from "~/containers/ToasterContainer"

const teamCreateMutation = graphql`
  mutation TeamCreateMutation($name: String!) {
    createTeam(name: $name) {
      team {
        id
        name
        account {
          id
          teams {
            id
          }
        }
      }
    }
  }
`

type CreateTeamRelayOptions = {
  variables: TeamCreateMutation["variables"]
}

export const teamCreateRelay = async (options: CreateTeamRelayOptions) => {
  const { variables } = options
  const data = await commitMutationPromise<TeamCreateMutation>(environment, {
    mutation: teamCreateMutation,
    variables,
  })
  const team = data.createTeam.team
  if (team) {
    showToast({
      type: "success",
      message: "New team created",
      description: team.name,
      actions: [{ href: viewTeamUrl(team.id) }],
      autoClose: 4000,
    })
  }

  return team
}

const teamUpdateMutation = graphql`
  mutation TeamUpdateMutation($teamId: Int!, $name: String!) {
    updateTeam(id: $teamId, name: $name) {
      team {
        id
        name
        account {
          id
          teams {
            id
            name
          }
        }
      }
    }
  }
`

type UpdateTeamRelayOptions = {
  variables: TeamUpdateMutation["variables"]
}

export const teamUpdateRelay = async (options: UpdateTeamRelayOptions) => {
  const { variables } = options

  const data = await commitMutationPromise<TeamUpdateMutation>(environment, {
    mutation: teamUpdateMutation,
    variables,
  })
  const team = data.updateTeam.team
  if (team) {
    showToast({
      message: "Updated team",
      description: team.name,
      type: "success",
      actions: [{ href: viewTeamUrl(team.id) }],
    })
  }

  return team
}

const teamDeleteMutation = graphql`
  mutation TeamDeleteMutation($id: Int!) {
    deleteTeam(id: $id) {
      account {
        id
        teams {
          id
        }
      }
    }
  }
`

export const teamDeleteRelay = async (
  variables: TeamDeleteMutation["variables"],
) => {
  const data = await commitMutationPromise<TeamDeleteMutation>(environment, {
    mutation: teamDeleteMutation,
    variables,
  })

  return data.deleteTeam.account.teams
}
